<template>
   <div v-html="pageContent.content">

   </div>
</template>

<script>
export default {
   data() {
      return {
         pageContent: {}
      }
   },

   async mounted() {
      const landingURL = this.$route.params.url;
      await this.getLanding(landingURL);
      window.$('.preloader-page').removeClass('proccess-load')
   },

   methods: {
      async getLanding(url) {
         try {
            const response = await fetch("/public/page/find", {
               method: "POST",
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify({ url })
            });


            if (!response.ok) {
               throw new Error('Сетевая ошибка: ' + response.statusText);
            }

            const data = await response.json();


            this.pageContent = data.result;
            console.log(" this.pageContent", this.pageContent)
         } catch (error) {
            console.error('Ошибка при получении данных:', error);
         }
      }

   }
}


</script>

<style lang="scss" scoped></style>